<template>
  <div class="invoicesGrid">
    <invoice-card v-for="(invoice, index) in state.admin.global.invoices.list" :key="index" @click="state.invoicesView = 'details'; state.user.invoices.activeInvoice = invoice" :invoice="invoice"></invoice-card>
  </div>
</template>
<script>
import dataStore from '@/dataStore';
import invoiceCard from '../molecules/invoiceCard';

export default {
  name: "invoicesGrid",
  data() {
    return {
      state: dataStore.state
    }
  },
  components: {
    'invoice-card': invoiceCard
  }
}
</script>
<style>
.invoicesGrid {display: grid; grid-template-columns: repeat(auto-fit, minmax(320px, 1fr)); grid-gap: 8px; padding: 8px;}
</style>


// WEBPACK FOOTER //
// src/system/organisms/invoicesGrid.vue